import { RequestsApi } from '../RequestsApi';

class ChatApi extends RequestsApi {
    async getChatsHistory(page) {
        return await this.request(`/chat?page=${page}`, 'get');
    }

    async initChat() {
        return await this.request('/chat', 'post');
    }

    async initChatWithAdvisor(advisorId) {
        return await this.request(`/chat/advisor/${advisorId}`, 'post');
    }

    async initChatWithAdvisorByActivities(activityId) {
        return await this.request(`/chat/activity/${activityId}`, 'post');
    }

    async getChatMessages(params) {
        const { chatId, page } = params;
        return await this.request(`/chat/${chatId}/messages?page=${page}`, 'get');
    }

    async connectToChat(chatId) {
        return await this.request(`/chat/${chatId}/connect`, 'post');
    }

    async sendChatMessage(params) {
        const { chatId, content, attachments } = params;
        return await this.request(`/chat/${chatId}/messages`, 'post', { content, attachments: attachments });
    }

    async deleteChat(chatId) {
        return await this.request(`/chat/${chatId}/`, 'delete');
    }

    async editChatName(chatId, name) {
        return await this.request(`/chat/${chatId}`, 'put', { name });
    }
    async getChatInfo(chatId) {
        return await this.request(`/chat/${chatId}`, 'get');
    }
    async loadImage(file) {
        return await this.request(`/chat/image/upload`, 'post', file, { 'Content-Type': 'multipart/form-data' });
    }
}

export default new ChatApi();
